export enum TableOfContentOrientationEnum {
    horizontal = 'HORIZONTAL',
    vertical = 'VERTICAL'
}
